import { render, staticRenderFns } from "./DelegateTabs.vue?vue&type=template&id=22ceb932&scoped=true"
import script from "./DelegateTabs.vue?vue&type=script&lang=js"
export * from "./DelegateTabs.vue?vue&type=script&lang=js"
import style0 from "./DelegateTabs.vue?vue&type=style&index=0&id=22ceb932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ceb932",
  null
  
)

export default component.exports